/** CrowdGenix uses UK day-first dates regardless of browser language. */
export function resolveAppLocale(
  _language?: string | null,
): string {
  return 'en-GB';
}
